import { render, staticRenderFns } from "./UploadedFilesDialog.vue?vue&type=template&id=11bec0b5&scoped=true"
import script from "./UploadedFilesDialog.vue?vue&type=script&lang=js"
export * from "./UploadedFilesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bec0b5",
  null
  
)

export default component.exports